import { OWEN_CHARACTER } from '../../config/owenAI';

const OwenAvatar = ({
  size = 'medium',
  showName = false,
  showTitle = false,
  showTooltip = true,
  online = true,
  style = {},
}) => {
  const sizes = {
    small: { width: 32, height: 32 },
    medium: { width: 48, height: 48 },
    large: { width: 64, height: 64 },
    xlarge: { width: 80, height: 80 },
  };

  const avatarSize = sizes[size] || sizes.medium;
  const dotSize = size === 'small' ? 8 : 12;

  const avatar = (
    <div
      style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--lk-space-2)', ...style }}
      title={showTooltip && !showName ? `${OWEN_CHARACTER.name} - ${OWEN_CHARACTER.title}` : undefined}
    >
      <div style={{ position: 'relative', display: 'inline-flex' }}>
        <img
          src={OWEN_CHARACTER.avatar}
          alt={OWEN_CHARACTER.name}
          style={{
            width: avatarSize.width, height: avatarSize.height, borderRadius: '50%',
            display: 'block', objectFit: 'cover',
          }}
        />
        {online && (
          <div style={{
            position: 'absolute', bottom: 2, right: 2,
            width: dotSize, height: dotSize,
            backgroundColor: 'var(--lk-success-500)', borderRadius: '50%',
            border: '2px solid var(--lk-bg-surface-1)',
          }} />
        )}
      </div>
      {(showName || showTitle) && (
        <div>
          {showName && (
            <div style={{ fontSize: 'var(--lk-text-sm)', fontWeight: 700 }}>
              {OWEN_CHARACTER.name}
            </div>
          )}
          {showTitle && (
            <div style={{ fontSize: 'var(--lk-text-xs)', color: 'var(--lk-text-tertiary)' }}>
              {OWEN_CHARACTER.title}
            </div>
          )}
        </div>
      )}
    </div>
  );

  return avatar;
};

export default OwenAvatar;
